import { api } from "@/api";
import { FullMatchDto } from "./getFullMatches";

export const manualAbandonMatch = async (matchId: string): Promise<FullMatchDto> => {
  const res = await api.client.post(`/matches/${matchId}/manual-abandon`);
  return res.data;
};
